export class FiltroLogDTO {
  public usuarioId!: number | null;
  public usuarioLogin!: string | null;
  public usuarioNome!: string | null;
  public dataHoraInicio!: string | null;
  public dataHoraFim!: string | null;
  public ipAcesso!: string | null;
  public tipoTransacaoLog!: number | null;
  public status!: boolean | null;
  public cpfCliente!: string | null;
  public nomeCliente!: string | null;
  public matriculaCliente!: string | null;
  public idEmpregador!: number | null;
  public idPromotora!: number | null;
  public idPontoVenda!: number | null;
  public propostaSolicitada!: boolean | null;
}